export default class MasterAccountSearch {
	filterText: string = '';
	filterField: string = '';
}